import React, { useEffect, useState } from "react";
import { useParams,Link, useLocation } from "react-router-dom";
import NewPropertySearchControl from "../components/newpropertysearchcontrol";
import "../components/PropertySearch.css";
import axios from "axios";
import CTA from "../components/cta";
const PAGE_SIZE = 9;

const NewProjectsbyDeveloper = () => {
  const { id } = useParams();
  const location = useLocation();

  const [filters, setFilters] = useState({
    offering_type: "Latest Launches",
    id: id 
  });

  const [listings, setListings] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [developername, setdevelopername] = useState(0);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [sortBy, setSortBy] = useState("id DESC"); 
const API =  process.env.REACT_APP_API_URL || "https://nvrealestate.websiteseoonline.com";

  const shown = listings.length;

  // 🔥 FETCH API
  const fetchListings = async (pageNo, isLoadMore, currentFilters) => {
    setLoading(true);

    try {
      const body = {
        page: pageNo,
        pageSize: PAGE_SIZE,
        sortBy,
        ...currentFilters
      };

      const res = await fetch(`${API}/api/offplanprojectbydeveloper.ashx`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(body)
        }
      );

      const result = await res.json();

      if (result.result === 1) {
        setTotal(result.total || 0);
        setdevelopername(result.developername || 0);
        setListings(prev =>
          isLoadMore ? [...prev, ...(result.data || [])] : result.data || []
        );
        setHasMore(pageNo * PAGE_SIZE < (result.total || 0));
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // 🔁 SYNC FILTERS FROM URL (CRITICAL FIX)
  useEffect(() => {
    const query = new URLSearchParams(location.search);

    const newFilters = {
      offering_type: query.get("offering_type") || "Latest Launches",
       id: id, // ✅ KEEP THIS
      city: query.get("city") || "",
      property_category: query.get("property_category") || "Residential",
      property_type: query.get("property_type") || "",
      bedrooms: query.get("bedrooms") || "",
      bathrooms: query.get("bathrooms") || "",
      minArea: query.get("minArea") || "",
      maxArea: query.get("maxArea") || "",
      minPrice: query.get("minPrice") || "",
      maxPrice: query.get("maxPrice") || ""
    };

    setFilters(newFilters);
    setPage(1);
    fetchListings(1, false, newFilters);
  }, [location.search, sortBy]);

  // 🔍 SEARCH FROM FILTER BAR
  const handleSearch = (payload) => {
    setFilters(payload);
    setPage(1);
    fetchListings(1, false, payload);

    const queryStr = new URLSearchParams(payload).toString();
    window.history.replaceState(null, "", `/new-projects?${queryStr}`);
  };

  // ➕ LOAD MORE
  const handleLoadMore = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    fetchListings(nextPage, true, filters);
  };

  return (
    <>
      <section
    className="flat-title-page mrg-0 boder-r-0"
    style={{
      backgroundImage:
        "url(/images/img/new-projects.jpg)"
    }}
  >
    <div className="container">
      <div className="breadcrumb-content">
        <h1 className="text-center text-white title">Latest Launches - {developername}</h1>
         <div className="container">
        <section
          className="flat-filter-search-v2-newproject flat-section flat-recommended pt-0"
          style={{ marginTop: 2 }}
        > 
            <NewPropertySearchControl
              defaultValues={filters}
              onSearch={handleSearch}
            /> 
        </section>
      </div>
      </div>
    </div>
  </section> 
      <div className="container">
    <div className="property-search-page"> 
      <div className="container">
        <section className="flat-section pt-0">
          <div className="box-title-listing">
            <div className="box-left">
              <h3 className="title fw-8">Off Plan Search Result</h3>
              <p>Showing {shown} properties out of {total}</p>
            </div>

            <div className="box-filter-tab">
             <select
                  className="nice-select select-filter list-sort"
                  value={sortBy}
                  onChange={(e) => setSortBy(e.target.value)}
                > 
                  <option value="id DESC">Newest</option>
                  <option value="id ASC">Oldest</option>
                  <option value="price ASC">Price: Low → High</option>
                  <option value="price DESC">Price: High → Low</option>
                </select>
            </div>
          </div>

          <div className="row">
              {listings?.map(item => (
                        <div className="col-xl-4 col-lg-6 col-md-6">
                                          <div className="homelengo-box">
                                            <div className="archive-top">
                                              <Link className="images-group" to={`/off-plan-property/${item.url}`}>
                                                <div className="images-style">
                                                 <img src={item.ImagePath+'/w=421,sharpen=1'} alt={item.title}  className=" ls-is-cached lazyloaded" />
                                                </div>
                                                <div className="top">
                                                  <ul className="d-flex gap-6">
                                                    <li className="flag-tag primary">
                                                     {item.paymentplan} Payment Plan
                                                    </li>
                                                     <li className="flag-tag style-1">
                                                     {item.moveinstatus}
                                                    </li>
                                                  </ul>
                                                </div>
                                              </Link>
                                            </div>
                                            <div className="archive-bottom">
                                              <div className="content-top">
                                                <h6 className="text-capitalize">
                                                  <Link className="link" to={`/off-plan-property/${item.url}`}>
                                                   {item.title}
                                                  </Link>
                                                </h6>
                                                <p>
                                                  <svg
                                                    width={16}
                                                    height={16}
                                                    viewBox="0 0 16 16"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                  >
                                                    <path
                                                      d="M10 7C10 7.53043 9.78929 8.03914 9.41421 8.41421C9.03914 8.78929 8.53043 9 8 9C7.46957 9 6.96086 8.78929 6.58579 8.41421C6.21071 8.03914 6 7.53043 6 7C6 6.46957 6.21071 5.96086 6.58579 5.58579C6.96086 5.21071 7.46957 5 8 5C8.53043 5 9.03914 5.21071 9.41421 5.58579C9.78929 5.96086 10 6.46957 10 7Z"
                                                      stroke="#000"
                                                      strokeWidth="1.5"
                                                      strokeLinecap="round"
                                                      strokeLinejoin="round"
                                                    />
                                                    <path
                                                      d="M13 7C13 11.7613 8 14.5 8 14.5C8 14.5 3 11.7613 3 7C3 5.67392 3.52678 4.40215 4.46447 3.46447C5.40215 2.52678 6.67392 2 8 2C9.32608 2 10.5979 2.52678 11.5355 3.46447C12.4732 4.40215 13 5.67392 13 7Z"
                                                      stroke="#000"
                                                      strokeWidth="1.5"
                                                      strokeLinecap="round"
                                                      strokeLinejoin="round"
                                                    />
                                                  </svg>
                                                 {item.community}, {item.city}
                                                </p>
                                                 <ul className="meta-list">
                          {(Array.isArray(item.property_type)
                            ? item.property_type
                            : (item.property_type || "").split("|")
                          ).map((type, i) => (
                            <li key={i} className="item border">
                              {type.trim()}
                            </li>
                          ))}
                        </ul>
                                          
                                              </div>
                                                    <div className="content-bottom mb-10">
                                                           <Link  className="whitefont fullwidth" to={`/off-plan-property/${item.url}`}>
                                                           <h6 className="price">
                                                           Starting From  AED {item.price}
                                                           </h6>
                                                           </Link>
                                                         </div>
                                              <div className="content-bottom ">
                                                <div className="property-icns-w">
                                                  <Link to="tel:+971501577822">
                                                    {" "}
                                                    <i className="icon">
                                                      <img src={process.env.PUBLIC_URL + "/images/img/phone.svg"} />
                                                    </i>
                                                    Call
                                                  </Link>
                                                  <Link to="mailto:info@nvrealestate.ae">
                                                    {" "}
                                                    <i className="icon">
                                                      <img src={process.env.PUBLIC_URL + "/images/img/email.svg"} />
                                                    </i>
                                                    Email
                                                  </Link>
                                                  <Link
                                                  to={`https://web.whatsapp.com/send?phone=971544544287&text=Hi, I am interested in the listing, ${item.title}, from your website. I would like to get more information, please. Thank you.`}
                                                  target="_blank"
                                                  >
                                                    <i className="icon">
                                                      <img src={process.env.PUBLIC_URL + "/images/img/whatsapp.svg"} />
                                                    </i>{" "}
                                                    Whatsapp
                                                  </Link>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                          ))}
          </div>

          {hasMore && (
            <div className="text-center mt-4">
              <button
                className="tf-btn-full btn-line"
                onClick={handleLoadMore}
                disabled={loading}
              >
                {loading ? "Loading..." : "Load More"}
              </button>
            </div>
          )}
        </section>
      </div>
    </div> 
    </div>
    <CTA/>
    </>
  );
};

export default NewProjectsbyDeveloper;
